var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteIconGas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 90,
    viewBox: "0 0 107 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 85,
    height: 68,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7693 32.5816L63.2784 27L61.5878 28.6714L65.6749 32.1857C64.59 32.7916 63.8462 33.9299 63.8462 35.25C63.8462 37.1995 65.451 38.7858 67.4231 38.7858C67.8427 38.7858 68.241 38.701 68.6151 38.5689V48.2142C68.6151 49.5156 67.5467 50.5715 66.2307 50.5715C64.9142 50.5715 63.8462 49.5156 63.8462 48.2142V44.6785C63.8462 42.7293 62.241 41.1427 60.2693 41.1427H59.0769V31.7142C59.0769 30.4132 58.0085 29.3573 56.6924 29.3573H44.7693C43.4529 29.3573 42.3845 30.4132 42.3845 31.7142V55.2858C42.3845 56.5868 41.3165 57.6427 40 57.6427V60H61.4614V57.6427C60.1453 57.6427 59.0769 56.5868 59.0769 55.2858V43.5H60.2693C60.9249 43.5 61.4614 44.0303 61.4614 44.6785V48.2142C61.4614 50.8142 63.6006 52.9285 66.2307 52.9285C68.8608 52.9285 71 50.8142 71 48.2142V35.25C71 34.2271 70.5514 33.2535 69.7693 32.5816ZM44.7693 34.0715H56.6924V41.1427H44.7693V34.0715ZM67.4231 36.4285C66.7671 36.4285 66.2307 35.9005 66.2307 35.25C66.2307 34.5995 66.7671 34.0715 67.4231 34.0715C67.788 34.0715 68.0453 34.2247 68.2003 34.3568L68.2052 34.3612C68.4673 34.5852 68.6151 34.9082 68.6151 35.25C68.6151 35.9005 68.0787 36.4285 67.4231 36.4285Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 107,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconGas);
export default __webpack_public_path__ + "static/media/WhiteIcon_Gas.70d67da565babd729adc921ca2087911.svg";
export { ForwardRef as ReactComponent };